import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Form, Formik } from 'formik';
import Button from "../../../components/buttons/Button";
import StyledHeadingText from "../../../components/Fonts/StyledHeadingText";
import Table from "../../../components/tables/Table";
import { formatDateTime } from "../../../utils/FormatDateTime";
import InputField from "../../../components/inputFields/InputField";
import { toast } from "react-toastify";
import { addHudPatientPackageComment } from "../../../services/hud/hud_patients";

const PatientPackageComment = ({ packageId, packageComments, onAddNewComment }) => {
    const headers = [
        { label: "S. No.", key: "i" },
        { label: "Comment", key: "package_comment" },
        { label: "Date", key: "created_at" },
    ];
    const [tableData, setTableData] = useState([]);

    const fetchData = async (packageComments) => {
        setTableData(packageComments);
    };

    useEffect(() => {
        fetchData(packageComments);
    }, []);


    const handleSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        try {
            const response = await addHudPatientPackageComment(packageId, values);
            if (response?.status === 201) {
                onAddNewComment();
                toast.success("Comment added successfully!");
            } else {
                toast.error("Oops! Something went wrong, please try again.");
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Oops! Something went wrong, please try again.";
            toast.error(errors);
        } finally {
            setSubmitting(false);
        }
    };

    const validationSchema = Yup.object({
        comment: Yup.string().required("Comment is required"),
    });

    return (
        <>
            <div className="w-full flex-1">
                <StyledHeadingText text="Package Comments" />
                <Formik
                    initialValues={{ comment: "" }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting, setFieldValue, values }) => (
                        <Form className="space-y-4 my-4">
                            <div className="flex gap-4 flex-col">
                                <InputField
                                    label={"Comment"}
                                    name="comment"
                                    type="text"
                                    placeholder="Enter your comment here..."
                                    required
                                />
                                <Button
                                    type="submit"
                                    className="bg-primary text-white px-4 py-2 rounded max-w-32"
                                    disabled={isSubmitting}
                                >
                                    {"Add"}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
                {<Table
                    headers={headers}
                    rows={tableData.map((item, index) => (
                        {
                            i: <p>{index + 1}</p>,
                            created_at: <p>{formatDateTime(item.created_at)}</p>,
                            package_comment: <p>{item.comment}</p>,
                        }))}
                />
                }
            </div >
        </>
    );
};

export default PatientPackageComment;
